import restClient from '../common/api/restClient';

export const isObject = value => {
  return value && typeof value === "object" && value.constructor === Object;
};

export const evaluateSecondStep = async (action, id) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  let res = await restClient({
    url: `${prefix}/challenge/${id}/evaluate-step`,
    method: 'post',
    data: {
      action
    }
  });
  return { data: { challengeStepEvaluator: res } };
};

export const evaluateThirdStep = async id => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  let evaluateSecondStep = await restClient({
    url: `${prefix}/challenge/${id}/evaluate-step`,
    method: 'post',
    data: {
      action: {
        actionNeeded: "click",
        target: "button",
        parameter: "submit"
      }
    }
  });
  let finalTarget = evaluateSecondStep;
  return finalTarget;
};
